<template>
  <el-card class="box-card" :body-style="{ padding: '0px' }">

    <div slot="header" class="clearfix">
      <span style="font-weight: 600">教学视频博主</span>
    </div>
    <div class="names-card" id="names-card">
      <!-- 人名列表将通过 JS 动态插入 -->
    </div>

    <div class="pagination-card" style="margin-top:16px;text-align:center;">
      <button id="prev" @click="changePage(-1)" aria-label="上一页"
              style="background:none;border:none;font-size:28px;padding:4px 18px;line-height:1.2;cursor:pointer;vertical-align:middle;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             style="vertical-align:middle;">
          <path d="M15 6L9 12L15 18" stroke="#6366f1" stroke-width="2.5" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </button>
      <span id="page-info" style="font-size:16px;margin:0 10px;vertical-align:middle;">1/1</span>
      <button id="next" @click="changePage(1)" aria-label="下一页"
              style="background:none;border:none;font-size:28px;padding:4px 18px;line-height:1.2;cursor:pointer;vertical-align:middle;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             style="vertical-align:middle;">
          <path d="M9 6L15 12L9 18" stroke="#6366f1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div id="tooltip" class="tooltip"></div>
  </el-card>
</template>

<script>
import axios from 'axios'

const itemsPerPage = 20; // 每页固定显示20个人名

export default {
  name: "BiliUpList",
  props: {
    game: {type: Number, default: 1},
  },
  data() {
    return {
      biliUpList: [],
      currentPage: 1,
    }
  },
  mounted() {
    this.getBiliUpList()
  },
  methods: {
    getBiliUpList() {
      axios({
        method: 'get',
        url: '/api/blogs/get_bili_up_list',
        params: {
          game: this.game,
        }
      }).then(r => {
        if (r.data.code === 0) {
          this.biliUpList = r.data.list
          this.displayPage(this.currentPage)
        } else {
          this.$message.error('加载失败');
        }
      })
    },
    // 生成人名文字渐变色
    getGradientColor(index, total) {
      // 颜色从 #f43f5e（红）到 #22d3ee（青）跨度更大
      const start = [244, 63, 94];   // #f43f5e
      // const end = [34, 211, 238];    // #22d3ee
      const end = [152, 16, 250];    // #22d3ee
      const r = Math.round(start[0] + (end[0] - start[0]) * (index / (total - 1)));
      const g = Math.round(start[1] + (end[1] - start[1]) * (index / (total - 1)));
      const b = Math.round(start[2] + (end[2] - start[2]) * (index / (total - 1)));
      return `rgb(${r},${g},${b})`;
    },
    changePage(delta) {
      this.currentPage += delta
      this.displayPage(this.currentPage)
    },
    displayPage(page) {
      const card = document.getElementById('names-card');
      card.innerHTML = '';
      const tooltip = document.getElementById('tooltip');
      tooltip.style.opacity = 0;

      // 直接按固定数量分页
      const start = (page - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      let pageItems = this.biliUpList.slice(start, end);

      // 创建正式人名容器
      const namesWrapper = document.createElement('div');
      namesWrapper.style.display = 'flex';
      namesWrapper.style.flexWrap = 'wrap';
      namesWrapper.style.gap = '8px 12px';
      namesWrapper.style.width = '100%';
      namesWrapper.style.alignItems = 'flex-start';
      namesWrapper.style.overflow = 'hidden';
      namesWrapper.style.height = '100%';

      pageItems.forEach((upObj, idx) => {
        const link = upObj.url;
        const nameTag = document.createElement('a');
        nameTag.textContent = upObj.name;
        nameTag.href = link;
        nameTag.target = '_blank';
        nameTag.style.display = 'inline-block';
        nameTag.style.padding = '6px 12px';
        nameTag.style.margin = '0';
        nameTag.style.fontSize = '15px';
        nameTag.style.whiteSpace = 'nowrap';
        nameTag.style.textDecoration = 'none';
        nameTag.style.background = 'transparent';
        nameTag.style.transition = 'background 0.2s, color 0.2s';
        nameTag.style.color = this.getGradientColor(idx, pageItems.length);
        nameTag.onmouseover = (e) => {
          nameTag.style.background = '#dbeafe';
          nameTag.style.color = '#2563eb';
          tooltip.textContent = link;
          tooltip.style.opacity = 1;
          const rect = e.target.getBoundingClientRect();
          tooltip.style.left = rect.left + window.scrollX + 'px';
          tooltip.style.top = rect.bottom + window.scrollY + 6 + 'px';
        };
        nameTag.onmouseout = () => {
          nameTag.style.background = 'transparent';
          nameTag.style.color = this.getGradientColor(idx, pageItems.length);
          tooltip.style.opacity = 0;
        };
        namesWrapper.appendChild(nameTag);
      });
      card.appendChild(namesWrapper);
      // 计算总页数
      let totalPages = Math.ceil(this.biliUpList.length / itemsPerPage);
      document.getElementById('page-info').textContent = `${page}/${totalPages}`;
      document.getElementById('prev').disabled = page === 1;
      document.getElementById('next').disabled = page === totalPages;
    },
  }
}
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}

body {
  font-family: Arial, sans-serif;
  background-color: #f4f4f4;
  margin: 0;
  padding: 20px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.names-card {
  background: #fff;
  /*border: 1px solid #ddd;*/
  /*border-radius: 8px;*/
  /*box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);*/
  /*margin: 10px;*/
  /*padding: 20px;*/
  /*width: 400px;*/
  height: 240px; /* 5行，每行约48px，含padding */
  text-align: left;
  transition: transform 0.2s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/*.card:hover {*/
/*  transform: scale(1.05);*/
/*}*/

.pagination-card {
  text-align: center;
  margin: 0;
}

.pagination-card button {
  margin: 0 5px;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.pagination-card button:focus {
  outline: none;
}

.pagination-card button:disabled {
  background-color: #ccc;
}

.tooltip {
  position: absolute;
  background: #222;
  color: #fff;
  border: 1px solid #333;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  z-index: 999;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}
</style>